import { Warning } from "@/components/shared/icons";
import { View } from "@/components/ui";
import { cn } from "@/lib/utils";

import { Typography } from "../../typography";

export const ErrorMessage = ({
  errorMessage,
  className,
}: {
  errorMessage: string | React.ReactNode;
  className?: string;
}) => {
  if (!errorMessage) return <></>;
  return (
    <View
      className={cn(
        "border-secondary-border bg-primary-surface text-secondary-text flex flex-row items-center gap-2 rounded-lg border p-3",
        className,
      )}
    >
      <Warning weight="fill" size={20} className="color-secondary-text shrink-0" />

      <View className="flex-1 text-wrap">
        {typeof errorMessage === "string" ? (
          <Typography variant="caption-md" color="secondary-text" className="w-full">
            {errorMessage}
          </Typography>
        ) : (
          errorMessage
        )}
      </View>
    </View>
  );
};
